import { useAuthSession } from "src/hooks/useAuthSession";
import { NotFound } from "src/routes/NotFound";
import { AuthenticatedShell } from "src/routing/components/AuthenticatedShell";
import { RouteEnvironmentProviders } from "src/routing/components/RouteEnvironment";

/** Auth-aware catch-all for URLs that match no domain tree.
 *
 * Role: data router root `Component` on the `*` NotFound route.
 *
 * Authenticated: same logged-in stack as `AppShell` (`AuthenticatedShell` → nav chrome → NotFound).
 * Unauthenticated: bare `NotFound` (no nav) — do not redirect to `/signIn`.
 * Does not save a deep link — sending someone back to a 404 after login is useless.
 */
export function NotFoundShell() {
  const { isAuthenticating, isAuthenticated } = useAuthSession();

  if (isAuthenticating) {
    return <div />;
  }

  if (!isAuthenticated) {
    return (
      <RouteEnvironmentProviders>
        <NotFound />
      </RouteEnvironmentProviders>
    );
  }

  // Same post-gate stack as AppShell: providers + <Outlet/>. The `*` child is NotFound
  // under GlobalNav — rendering <NotFound/> here would drop logged-in chrome.
  return <AuthenticatedShell />;
}
